import React from 'react'
import Profile from '../components/Profile'
import hipladeTemplate from '../../common/template'

function UsersProfile() {
  return <Profile />
}

export default hipladeTemplate(UsersProfile)
